import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_shell/")({
  beforeLoad: () => {
    throw redirect({ to: "/shopping" });
  },
});
